module.exports = __webpack_public_path__ + "images/5-i72dd6b41cdcdba0c9f07680da9887e4e.svg";